import { getImage } from './getImage';

export function preloadImage(imagePath: string): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    const imageUrl = getImage(imagePath);
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => reject(new Error(`Failed to load image: ${imageUrl}`));
    img.src = imageUrl;
  });
}

export function preloadImages(imagePaths: string[]): Promise<void[]> {
  return Promise.all(imagePaths.map((path) => preloadImage(path)));
}
